
//import { Component, OnInit } from '@angular/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PageResponseModel } from 'src/app/core/models/page.model';



@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {

  @Input() page!: PageResponseModel<any>;
  @Output() onPageSizeChange = new EventEmitter<number>();

  @Output() onPageChange = new EventEmitter<number>(); 

  lastItemInpage = 0;
  pageList: any;
  isShowPaginator = false;

  constructor() { 
    window.addEventListener('resize', (event: any) => { 
      if(window.innerWidth <= 550){
        this.genPageData(this.end2,this.page.pageNumber)
      }else{
        this.genPageData(this.end,this.page.pageNumber)
      }
      this.generatePage();
      // event.returnValue = `You have unsaved changes, leave anyway?`;
    });
  }

  ngOnInit(): void {
    this.page = new PageResponseModel();
    this.setPageResult(this.page)
  }


  handlePageSizeChange(value: string) {
    const pageSize = parseInt(value);
    this.onPageSizeChange.emit(pageSize);
  }

  setPagination(mode: string = '', pageNo: number, lastPage: number) {
    if ((mode === 'first' && pageNo > 1) || (mode === 'prev' && pageNo > 1) || (mode === 'next' && pageNo !== lastPage) || (mode === 'last' && pageNo !== lastPage) || (mode === 'increase' && pageNo < (lastPage - 10)) || (mode === 'reduce' && pageNo > 10)) {
      this.page.pageNumber = this.resultPagination(mode, pageNo, lastPage);
      this.generatePage();
      this.goPageReturn();
    }
  }

  getShowing() {
    const result = (this.page.pageSize * this.page.pageNumber) - this.page.pageSize + 1;
    if (isNaN(result)) {
      return 0;
    }

    return result;
  }

  public setPageResult(page: PageResponseModel<any>) {
    this.isShowPaginator = page.totalItemCount > 0;
    this.page = page;
    this.generatePage();
  }

  private generatePage() {
    const pDt = this.genPageData(this.page.pageCount, this.page.pageNumber);
    this.pageList = pDt.pageList;
    this.lastItemInpage = (this.page.pageNumber === this.page.pageCount) ? this.page.totalItemCount : (this.page.pageSize * this.page.pageNumber);
  }

  goPageObj(obj: any) {
    if (!obj.active) {
      this.page.pageNumber = obj.num;
      this.generatePage();
      this.goPageReturn();
    }
  }

  private goPageReturn() {
    this.onPageChange.emit(this.page.pageNumber);
  }
  start = 1;
  end = 10; 

  start2 = 1;
  end2 = 5;
  private genPageData(lastPage: number, pageNo: number) { 

    
    let pageList = [{ num: 1, active: true }]; 
    if(window.innerWidth <= 550){
      let add = 5;
      if (lastPage > 1) {
        if (pageNo > this.end2) {
          this.start2 = this.start2 + add
          this.end2 = this.end2 + add
        }
        if (pageNo < this.start2) {
          this.start2 = this.start2 - add ;  
          this.end2 = this.end2 - add;  
          if((this.end2 % add) > 0){  
            this.end2 = this.end2+ (add - (this.end2% add)) 
          }  
        }
        if(pageNo <= 1){
          this.start2 = 1;
          this.end2 = 5;
        }
        if(pageNo >= lastPage){ 
          this.start2 = lastPage - (lastPage % add) + 1;
          this.end2 = lastPage;
        }
  
        if(this.start2 > this.end2){  
          this.start2 =  this.start2 - add; 
        }
  
        this.start2 = pageNo <= 1 ? 1 : this.start2;
        this.end2 = lastPage >= this.end2 ? this.end2 : lastPage; 
        pageList = [];
        for (let i = this.start2; i <= this.end2; i++) {
          const row = { num: i, active: (i === pageNo) ? true : false };
          pageList.push(row);
        }
      }
    }else{
      let add = 10;
      if (lastPage > 1) {
        if (pageNo > this.end) {
          this.start = this.start + add
          this.end = this.end + add
        }
        if (pageNo < this.start) {
          this.start = this.start - add ;  
          this.end = this.end - add;  
          if((this.end % add) > 0){  
            this.end = this.end+ (add - (this.end % add)) 
          }  
        }
        if(pageNo <= 1){
          this.start = 1;
          this.end = 10;
        }
        if(pageNo >= lastPage){ 
          this.start = lastPage - (lastPage % add) + 1;
          this.end = lastPage;
        }
  
        if(this.start > this.end){  
          this.start =  this.start - add; 
        }
  
        this.start = pageNo <= 1 ? 1 : this.start;
        this.end = lastPage >= this.end ? this.end : lastPage; 
        pageList = [];
        for (let i = this.start; i <= this.end; i++) {
          const row = { num: i, active: (i === pageNo) ? true : false };
          pageList.push(row);
        }
      }
    } 

    return { pageList: pageList };
  }

  private pageData(lastPage: number, pageNo: number) {
    let pageList = [{ num: 1, active: true }];
    let start = 1;
    let end = 1;

    if (lastPage > 1) {
      start = ((pageNo - 4) <= 0) ? pageNo : (pageNo - 3);
      end = ((pageNo + 3) >= lastPage) ? lastPage : (pageNo + 4);

      pageList = [];
      for (let i = start; i <= end; i++) {
        const row = { num: i, active: (i === pageNo) ? true : false };
        pageList.push(row);
      }
    }
    return { pageList: pageList, lastPage: lastPage, start: start, end: end };
  }

  private resultPagination(mode: string = '', pageNo: number, lastPage: number) {
    let thePage = 1;
    if (mode === 'first' && pageNo > 1) {
      thePage = 1;
    } else if (mode === 'prev' && pageNo > 1) {
      if (pageNo !== 1) {
        thePage = pageNo - 1;
      }
    } else if (mode === 'next' && pageNo !== lastPage) {
      if (pageNo !== lastPage) {
        thePage = pageNo + 1;
      }
    } else if (mode === 'last' && pageNo !== lastPage) {
      thePage = lastPage;
    }

    else if (mode === 'increase' && pageNo !== (lastPage - 10)) {
      thePage = pageNo;
    }

    else if (mode === 'reduce' && pageNo !== (lastPage + 10)) {
      thePage = pageNo;
    }

    return thePage;
  }


}
